import { render, staticRenderFns } from "./LiveVehicleList.vue?vue&type=template&id=67dcef1d"
import script from "./LiveVehicleList.vue?vue&type=script&lang=js"
export * from "./LiveVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports